import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function HelpDialogContent() {
  return (
    <Box sx={{ mb: "3em" }}>
      <Typography>
        Please click{" "}
        <a
          target="_blank"
          href="https://tylertech.accessgov.com/usvi-cannabis/Forms/Page/usvi-cannabis/usvi-faq"
          rel="noopener noreferrer"
        >
          here
        </a>{" "}
        to view the FAQs and click{" "}
        <a
          target="_blank"
          href={`${process.env.PUBLIC_URL}/resources/USVI-OCR-INDUSTRY-TM.pdf`}
          rel="noopener noreferrer"
        >
          here
        </a>{" "}
        to view the user guide.
      </Typography>
      <Typography>
        For policy and procedural support, please contact the Office of Cannabis
        Regulations at{" "}
        <a href="mailto:info.ocr@ocr.vi.gov" target="_top">
          info.ocr@ocr.vi.gov
        </a>{" "}
        . Thank you!
      </Typography>

      <Typography>
        For technical support and payment questions, please visit Tyler
        Technologies support portal{" "}
        <a href="https://cannabislicensing.zendesk.com/hc/en-us" target="_top">
          here
        </a>
        ,
        <>
          <span> submit a support request </span>
          <a href="https://cannabislicensing.zendesk.com/hc/en-us/requests/new">
            here
          </a>
          ,<span> or call </span>
          <a href="tel:(340)-714-9755">(340)-714-9755</a>{" "}
        </>
        . Thank you!
      </Typography>
    </Box>
  );
}

export default HelpDialogContent;
